<template>
  <Dialog v-model="visible">
    <div class="throw-all-reward">
      <div class="tip">
        {{ $t('monopoly.throwAllRewardTip', { steps: props.totalSteps }) }}
      </div>
      <div class="reward-grid" v-if="props.rewards.length">
        <div
          class="reward-item"
          v-for="(item, index) in props.rewards"
          :key="`${item.propId || item.propName}-${index}`"
        >
          <div class="icon-wrap">
            <img
              v-if="item.propId"
              class="icon"
              :src="getPropIcon(item.propId)"
              :alt="item.propId"
            >
          </div>
          <div class="name">
            {{ formatPropText(t, item) }}
          </div>
        </div>
      </div>
      <div class="empty" v-else>
        {{ $t('monopoly.rewardEmpty') }}
      </div>
    </div>
  </Dialog>
</template>

<script setup>
import { computed, defineProps, defineEmits } from 'vue'
import { useI18n } from 'vue-i18n'
import Dialog from '../Dialog/index.vue'
import { getPropIcon, formatPropText } from '@/views/act/monopoly/utils/prop'

const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false,
  },
  totalSteps: {
    type: Number,
    default: 0,
  },
  rewards: {
    type: Array,
    default: () => [],
  },
})

const emit = defineEmits(['update:modelValue'])
const { t } = useI18n()

const visible = computed({
  get: () => props.modelValue,
  set: (val) => emit('update:modelValue', val),
})
</script>

<style lang="less" scoped>
.throw-all-reward {
  width: 100%;
  color: #12215c;
  text-align: left;
}

.tip {
  font-size: 28px;
  font-weight: bold;
  line-height: 1.5;
  margin-bottom: 28px;
  padding-right: 40px;
}

.reward-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px 16px;
  width: 100%;
}

.reward-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.icon-wrap {
  width: 96px;
  height: 96px;
  border-radius: 50%;
  border: 3px solid #E0FCFE;
  background: #b8e9ff;
  margin-bottom: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  box-sizing: border-box;
}

.icon {
  width: 72%;
  height: 72%;
  object-fit: contain;
}

.name {
  font-size: 24px;
  line-height: 1.3;
}

.empty {
  width: 100%;
  text-align: center;
  font-size: 26px;
  color: rgba(18, 33, 92, 0.6);
  padding: 40px 0;
}
</style>
